import { render, staticRenderFns } from "./rfq-tab-techsupplier.vue?vue&type=template&id=6675fd80"
import script from "./rfq-tab-techsupplier.vue?vue&type=script&lang=js"
export * from "./rfq-tab-techsupplier.vue?vue&type=script&lang=js"
import style0 from "./rfq-tab-techsupplier.vue?vue&type=style&index=0&id=6675fd80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports